/**
 * Holi menus — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_shivratri_holi`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const holiMenusPack: ToilePack = {
    slug: 'holi-menus',
    category: 'faith',
    name: 'Holi menus',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 832, h: 1216},
    readings: [
        {key: 'sweets', label: 'Sweets and drinks', subject: 'a vertical menu headed "Holi Menu" listing "Gujiya", "Malpua", "Dahi Bhalla", "Thandai" and "Kanji Vada" in clear lines, colour splashes at the corners'},
        {key: 'party', label: 'Party buffet', subject: 'a vertical menu headed "Holi Feast" with three sections, "Snacks", "Mains" and "Sweets", each with a few blank lines to fill in, a border of marigolds'},
        {key: 'thali', label: 'Holi thali', subject: 'a vertical menu headed "Holi Thali" with a drawing of a steel thali and its dishes labelled "Puri", "Aloo Sabzi", "Kachori" and "Gujiya"'},
    ],
    styles: [
        {key: 'chalkboard', label: 'Chalkboard', style: 'chalkboard lettering with hand-drawn chalk borders and powdery colour dust', palette: 'pink, yellow, green and blue chalk on matte black', framing: 'the menu centered with a chalk border and margin'},
        {key: 'clean', label: 'Clean print', style: 'clean modern print layout with a bold heading and a tidy single-column list', palette: 'magenta heading with dark grey text and small colour splashes on white', framing: 'text block centered with wide margins on every side'},
        {key: 'folk', label: 'Folk border', style: 'folk illustration with a painted marigold border and decorative dividers', palette: 'saffron, vermilion and leaf green on cream', framing: 'bordered by the painted frame inside a margin'},
    ],
    directions: ['vegan dishes', 'kids party', 'restaurant special'],
    directionHint: 'try: vegan dishes',
    seo: {
        title: 'Holi menus: sweets and drinks, party buffet, thali',
        metaDescription: 'Nine printable Holi menus for a family lunch, a society party or a festival day, with dish names in clear lines, in three styles.',
        h1: 'Holi menus: sweets and drinks, party buffet, Holi thali',
        tagline: 'Nine menus, three layouts in three styles each, for home, a party or a restaurant.',
        intro: "Menus for a Holi lunch at home, a society party or a restaurant's festival day, to print and set on the table. Each carries its dish names in clear lines under a colourful heading: Gujiya, Malpua, Dahi Bhalla, Thandai and Kanji Vada; or a thali of Puri, Aloo Sabzi, Kachori and Gujiya; or a party menu in sections of Snacks, Mains and Sweets. Type a different menu, such as vegan dishes, and the same layouts carry it.",
        useCases: [
            'A table menu for a family Holi lunch',
            'A menu card for a society party',
            'A festival day menu for a restaurant',
            'A menu for a school or office Holi lunch',
        ],
        faq: [
            {q: 'Can I change the dishes?', a: 'Yes. A dish list you type is a request; the samples keep the dishes shown.'},
            {q: 'Are there blank lines to fill in?', a: 'The party buffet menu has blank lines under Snacks, Mains and Sweets for you to fill in.'},
            {q: 'What is the difference between the three styles?', a: 'Chalkboard is chalk lettering on matte black, clean print is a magenta heading on white, and folk border is a painted marigold frame on cream.'},
        ],
    },
}
